import { Skeleton, Stack } from '@mui/material';

import Typography from '../../../../../../components/Typography';

const SlideIdentifierSkeleton = () => {
  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <Skeleton variant="rounded" width={20} height={20} />
      <Typography variant="textXsBold" component="h3" color="primary">
        <Skeleton variant="text" width={70} />
      </Typography>
    </Stack>
  );
};

export default SlideIdentifierSkeleton;
